import React from "react";

export default function Powerbi() {
  const reports = [
    {
      title: "HR Insights & Trends",
      src: "https://app.powerbi.com/view?r=eyJrIjoiZWM0NzhkN2EtMTJmZi00N2YxLTlmMWUtOGRiNjUxYjhiOGRjIiwidCI6IjJiZWQyYTE1LTRiNjktNDE3OC05NjhmLTQzYjNiOTFmMmY0YSJ9",
    },
    {
      title: "Restaurants Insights Dashboard",
      src: "https://app.powerbi.com/view?r=eyJrIjoiMzg3YTNjNDUtZDRiMi00ZWE2LTliMmUtYmUzYTY1NmY2OWVkIiwidCI6IjJiZWQyYTE1LTRiNjktNDE3OC05NjhmLTQzYjNiOTFmMmY0YSJ9",
    },
    {
      title: "Sales Analysis",
      src: "https://app.powerbi.com/view?r=eyJrIjoiNWQ1NjE0M2MtMjhhNS00ZWM1LWE1NWUtZTIwMDc1MjJhYThhIiwidCI6IjJiZWQyYTE1LTRiNjktNDE3OC05NjhmLTQzYjNiOTFmMmY0YSJ9",
    },
    {
      title: "Superstore Retail Performance Analyzer",
      src: "https://app.powerbi.com/view?r=eyJrIjoiNjI5ODU0MGItYjM4Ni00MDk2LTk4NGItMTkzMjZhZWU5MzhmIiwidCI6IjJiZWQyYTE1LTRiNjktNDE3OC05NjhmLTQzYjNiOTFmMmY0YSJ9",
    },
  ];

  return (
    <div className="container page-top pt-5" style={{ paddingTop: "6rem" }}>
      <h2 className="text-center mt-5 mb-4">
        <span className="text-danger fw-bold blink">Live</span> Interactive BI Dashboards
      </h2>
      <div className="row mt-5">
        {reports.map((report, index) => (
          <div className="col-12 col-md-6 mb-4" key={index}>
            <div className="ratio ratio-16x9">
              <iframe
                title={report.title}
                src={report.src}
                frameBorder="0"
                allowFullScreen
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  width: "100%",
                  height: "100%",
                }}
              ></iframe>
            </div>
            <p className="text-center mt-2 fw-bold">{report.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
